
import { Base } from '../base-component';

import './horizontal-buttons-item.component.scss';

export class HorizontalButtonsItem extends Base {

	constructor(element: Element){

		super(element);
				
	}

	init(){}

	bindEvents() {}
	
}



// WEBPACK FOOTER //
// ./components/horizontal-buttons-item/horizontal-buttons-item.component.ts